import { observer } from 'mobx-react'
import { FC, useContext } from 'react'
import { MenuItem, MenuItemSeparator } from '../ContextMenu.styles'
import { StoreContext } from '../../App'
import { copyToClipboard } from '@/methods/copyToClipboard'

interface ConfigurationListItemMenuProps {
  configType: 'clients' | 'entities'
}

export const ConfigurationListItemMenu: FC<ConfigurationListItemMenuProps> = observer(({ configType }) => {
  const store = useContext(StoreContext)
  const { contextMenu } = store.UserInterfaceState
  const { currentlyFocusedWindow } = store.CodeViewState

  const openTab = () => {
    store.CodeViewState.addTab({
      tab: {
        title: contextMenu.contextId,
        type: configType === 'clients' ? 'client' : 'entity',
        clientId: contextMenu.contextId,
      },
      side: currentlyFocusedWindow,
    })
  }

  const copyName = () => {
    if (contextMenu?.contextId) {
      copyToClipboard(contextMenu.contextId)
    }
  }

  return (
    <>
      <MenuItem onClick={openTab}>Open</MenuItem>
      {/* <MenuItem>Open right</MenuItem>
      <MenuItem>Open left</MenuItem> */}
      <MenuItemSeparator />
      <MenuItem onClick={copyName}>Copy name</MenuItem>
    </>
  )
})
